// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1BuVL","imageUploader":"EGiftCard_imageUploader__188OU"};